// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__RsviQ","header":"ReportDetails_header__2JUYu","title":"ReportDetails_title__G2P0B","left":"ReportDetails_left__3d4sK"};